import { BillingPaymentScheduleType } from "./billings";
import { IFilterItemApi, IFilters } from "./filters";
import { IOrdering, IPagination } from "./pagination";
import { ISearch } from "./search";
import { Status } from "./state";

export interface IBillingLocationApi {
  id: number;
  location_id: number;
  amount: string;
  net_amount: string;
  increase_comparison: number;
  household_members_count: number;
  name: string;
  enable_time: string;
  disable_time: string;
  previous_waste: number;
  is_paid: boolean;
  is_active: boolean;
  real_amount: string;
  current_waste: number;
  balance: string;
  waste_increase: string;
  payment_type: BillingPaymentScheduleType;
}

export interface IBillingLocation {
  id: number;
  locationId: number;
  amount: number;
  netAmount: number;
  increaseComparison: number;
  householdMembersCount: number;
  name: string;
  enableTime: string;
  disableTime: string;
  previousWaste: number;
  isPaid: boolean;
  isActive: boolean;
  realAmount: number;
  currentWaste: number;
  balance: number;
  wasteIncrease: number;
  paymentType: BillingPaymentScheduleType;
}

export interface IBillingLocationsState {
  status: Status;
  requestId: string;
  errorMsg: string | null;
  list: IBillingLocation[];
  billingId: number | null;
  isNextPageEnable: boolean;
  pagination: IPagination;
  ordering: IOrdering;
  filters: IFilters;
  search: ISearch;
  scrollTop: number;
}

export interface IBillingLocationsListRequest {
  fulltext?: string;
  pagination: IPagination;
  ordering: IOrdering;
  filters: IFilterItemApi[];
}

export enum BillingLocationsTableType {
  Calculation = "calculation",
  Billing = "billing",
}
